const brands = [
    { id: "0", name: "Other" },
    { id: "1", name: "Siemens" },
    { id: "2", name: "Signia" },
    { id: "3", name: "MiracleEar" },
    { id: "4", name: "NHS" },
    { id: "5", name: "VA" },
    { id: "6", name: "Audioservice" },
    { id: "7", name: "Dialog" },
    { id: "8", name: "Hoerluchs" },
    { id: "9", name: "ISMA" },
    { id: "10", name: "Kaulard" },
    { id: "11", name: "Meditrend" },
    { id: "12", name: "Opticland" },
    { id: "13", name: "OTON" },
    { id: "14", name: "Rexton" },
    { id: "15", name: "AM" },
    { id: "16", name: "Costco" },
    { id: "17", name: "SpecSavers" },
    { id: "18", name: "MedEl" },
    { id: "19", name: "Amplifon" },
    { id: "20", name: "TruHearing" },
    { id: "21", name: "Mimitakara" },
    { id: "22", name: "Miki" },
    { id: "23", name: "Afflelou" },
    { id: "24", name: "Vibe" },
    { id: "25", name: "audibene" },
    { id: "26", name: "hearDotCom" },
    { id: "27", name: "OuieZen" },
    { id: "28", name: "OptifitII" },
    { id: "29", name: "HCS" },
    { id: "30", name: "Kirkland Signature" },
    { id: "31", name: "Audibel" },
    { id: "32", name: "Impact" },
    { id: "33", name: "KOJ" },
    { id: "34", name: "Specsavers2" },
    { id: "36", name: "Stretta" },
    { id: "37", name: "AUDIO2000" },
    { id: "39", name: "Audibel" },
    { id: "40", name: "HearingGo" },
    { id: "41", name: "Viennatone" },
  ]
  const platforms = [
    {
      PlatformId: "18",
      PlatformName: "D9Plus",
    },
    {
      PlatformId: "19",
      PlatformName: "D10",
    },
    {
      PlatformId: "20",
      PlatformName: "D10_1",
    },
    {
      PlatformId: "21",
      PlatformName: "D11",
    },
    {
      PlatformId: "22",
      PlatformName: "D12",
    },
    {
      PlatformId: "23",
      PlatformName: "D12Plus",
    },
    {
      PlatformId: "24",
      PlatformName: "D13",
    },
    { PlatformId: "25", PlatformName: "F1" },
  ]

export { brands, platforms }